export default "__VITE_ASSET__09f20e4d__"